// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b3632fa8","125":"4235b7f9","258":"6b5ee473","498":"ac6fad23","703":"645b41c5"}[chunkId] + ".chunk.js";
};